import { nameToSlug, slugToClass } from 'utils/sanitize-category';

export function useCategoryColor(category) {
  const sanitizedCategory = nameToSlug(category);
  const classSelector = slugToClass(sanitizedCategory);
  const subcats = {
    travel: 'travel',
    automotive: 'travel',
    destination: 'travel',
    foodBeverage: 'travel',
    hotelsResorts: 'travel',
    realEstate: 'travel',
    technology: 'travel',
    lifestyle: 'lifestyle',
    artDesign: 'lifestyle',
    athletics: 'lifestyle',
    business: 'lifestyle',
    entertainment: 'lifestyle',
    events: 'lifestyle',
    fashionStyle: 'lifestyle',
    photography: 'lifestyle',
    spirituality: 'lifestyle',
    influencers: 'influencers',
    featured: 'featured',
    beautyCosmetics: 'lifestyle',
    beautyFashion: 'lifestyle',
    healthWellness: 'lifestyle',
    fitnessYoga: 'lifestyle',
  };
  return { sanitizedCategory, categoryColor: subcats[classSelector] };
}
